import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.sass';

import AppRoutes from './routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppRoutes/>
  </React.StrictMode>
);
